import { useState, useEffect } from 'react';

/**
 * Custom hook to detect screen size and determine if desktop view should be used
 * @param breakpoint - Breakpoint in pixels (default: 1024px)
 * @returns boolean indicating if desktop view should be used
 */
export function useResponsiveComponent(breakpoint: number = 1024): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() => {
    // Initialize with current window size if available
    if (typeof window !== 'undefined') {
      return window.innerWidth >= breakpoint;
    }
    return false;
  });

  useEffect(() => {
    // Early return if window is not available (SSR)
    if (typeof window === 'undefined') {
      return;
    }

    const handleResize = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isDesktop;
}